import {QrScanner} from "@yudiel/react-qr-scanner";
import {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {redirect, useNavigate, useParams} from "react-router-dom";
import {useRecoilState} from "recoil";
import {bottomBarState, userState} from "../../states/common";
import Navbar from "../../components/navbar";
import * as SBService from "../../helpers/sportbookService";
import {pingChallengeInvite} from "../../helpers/swissChallengePing";
import moment, {ISO_8601} from "moment";
import "../league/shared/league.css";
import { AnhPhongTo, Avatar, AvatarZoom } from "../league/shared/Avatar";
const ScanQR = () => {
    const params = useParams();
    const [qrLink, setQrLink] = useState('')
    const navigate = useNavigate();
    const [active, setActive] = useRecoilState(bottomBarState)
    const [user] = useRecoilState(userState)
    const [title, setTitle] = useState('')
    const [league, setLeague] = useState<{ id: any; name: any; type?: string }>({
        id: null,
        name: null
    })
    const [busy, setBusy] = useState(false)
    /* Giải bốc cặp sẵn (Swiss, Đấu kép): quét xong chưa mở trận ngay - hiện thông tin
       trận để người dùng bấm xác nhận, vì quét nhầm mã sẽ mở một trận không gỡ lại
       được. */
    const [doiThuDaQuet, setDoiThuDaQuet] = useState<{ id: string; name: string } | null>(null)
    /* Toàn bộ màn "thông tin trận đấu": hai vế cơ thủ, thể thức, điểm được mất.
       null khi backend chưa trả kịp hoặc trả lỗi - lúc đó vẫn hiện được tên và nút
       thách đấu, chỉ khuyết phần số. */
    const [matchup, setMatchup] = useState<any | null>(null)
    const [anhPhongTo, setAnhPhongTo] = useState<AnhPhongTo | null>(null)

    useEffect(() => {
        setActive('qr')
        let {mode} = params;
        if (mode === 'calibration') {
            setTitle('MINIGAME')
        } else if (mode === 'ranking') {
            setTitle('Đánh giá trình độ')
        } else if (!mode) {
            // Không kèm giải: máy quét tổng quát, việc gì là do nội dung mã và
            // vai trò người quét quyết định.
            setTitle('Quét mã QR')
        } else {
            loadLeagueDataById()
        }
    }, [])

    /**
     * Điều hướng cho máy quét tổng quát (đường /scan-qr không kèm giải).
     *
     * Hôm nay mã QR trong hệ thống chỉ có một loại: id cơ thủ. Viết dưới dạng
     * phân loại để nghiệp vụ sau — ví dụ check-in địa điểm — chỉ cần thêm một
     * nhánh, thay vì sửa lại toàn bộ chỗ này.
     */
    const dispatchGenericCode = (code: string) => {
        const value = code.trim()

        if (user?.isExpert) {
            // Chuyên gia quét mã cơ thủ là để đánh giá trình độ; thi đấu thì họ
            // dùng nút "Quét ngay" của từng giải.
            navigate(`/ranking/${value}`)
            return
        }

        toast.error('Mã QR này chưa dùng được ở đây. Dùng nút "Quét ngay" của giải bạn đang tham gia.')
        setQrLink('')
    }

    /**
     * Giải mà cặp đấu do BAN TỔ CHỨC bốc sẵn, không bắt kèo tự do.
     *
     * Hai thể thức này đi cùng một luồng quét mã: xem trước đối thủ, rồi mở đúng trận
     * của cặp đã bốc, rồi về trang giải. Chúng chỉ khác nhau ở hai endpoint, nên tách
     * ra một chỗ thay vì rải `=== 'SWISS'` khắp file - rải thì thêm thể thức thứ ba là
     * lại đi tìm từng chỗ, và chỗ bị bỏ sót sẽ im lặng rơi về màn bắt kèo tự do, vốn
     * mở ra một trận KHÔNG gắn với cặp nào trong sơ đồ.
     */
    const laGiaiBocCapSan = (type?: string) => type === 'SWISS' || type === 'DOUBLE-ELIMINATION'
    const laDauKep = (type?: string) => type === 'DOUBLE-ELIMINATION'

    const huyQuet = () => {
        setDoiThuDaQuet(null)
        setMatchup(null)
        setQrLink('')
    }

    /**
     * Nạp thông tin trận để người quét thấy mình sắp đánh với ai, thể thức nào và
     * được mất bao nhiêu điểm. CHƯA gọi API mở trận.
     *
     * Hỏng thì vẫn cho xác nhận, chỉ khuyết phần số: endpoint thách đấu đi qua đúng
     * lớp kiểm tra đó nên nó sẽ tự chặn nếu người này không phải đối thủ hợp lệ.
     * Chặn ở màn xem trước là biến một lỗi đọc thành ngõ cụt.
     */
    const xemTruocDoiThu = async (opponentId: string) => {
        let name = 'cơ thủ vừa quét'
        try {
            const rsp: any = laDauKep(league.type)
                ? await SBService.getDeMatchup(league.id, opponentId)
                : await SBService.getSwissMatchup(league.id, opponentId)
            const data = rsp?.data ?? rsp
            if (data?.opponent) {
                /* /de/matchup trả chạm ở gốc chứ không gói trong `format` như Swiss, và
                   nhánh kép thì không có hoà, không có chấp. Quy về CÙNG một hình dạng
                   ở đây, để khối hiển thị bên dưới không phải biết mình đang vẽ thể
                   thức nào - nó là một khối, và hai lối vẽ là hai lối trôi khỏi nhau. */
                setMatchup(
                    laDauKep(league.type)
                        ? { ...data, format: { race: data.race, drawAt: null, handicap: null } }
                        : data,
                )
                name = data.opponent.name || name
            }
        } catch (e: any) {
            try {
                const rsp = await SBService.getPlayerInLeagueData(league.id, opponentId)
                const data = rsp?.data ?? rsp
                name = data?.player?.name || data?.name || name
            } catch (e2: any) {
                // Tên cũng không tra được: vẫn hiện nút, để API thách đấu quyết định.
            }
        }
        setDoiThuDaQuet({ id: opponentId, name })
    }

    const moTranVoiDoiThu = async (opponentId: string) => {
        if (busy) return;
        setBusy(true)
        try {
            const rsp: any = laDauKep(league.type)
                ? await SBService.deChallenge(league.id, opponentId)
                : await SBService.swissChallenge(league.id, opponentId)
            const result = rsp?.data ?? rsp
            /* Quét một lần chỉ là gửi lời mời. Trận chỉ bắt đầu khi bên kia xác
               nhận — hoặc khi chính họ đã mời trước và lần quét này là cái gật đầu. */
            if (result?.state === 'accepted') {
                toast.success('Hai bên đã xác nhận, mời nhập kết quả')
            } else {
                await pingChallengeInvite(opponentId, {
                    challengerId: user.id,
                    challengerName: user.name || 'Đối thủ của bạn',
                    leagueId: league.id,
                    leagueName: league.name || '',
                })
                toast.success('Đã gửi lời thách đấu, chờ đối thủ xác nhận')
            }
            navigate(`/league/${league.id}`)
        } catch (e: any) {
            const code = e?.response?.data?.error;
            const messages: Record<string, string> = {
                notPairedThisRound: 'Người này không phải đối thủ của bạn ở vòng hiện tại',
                noOpenRound: 'Vòng đấu chưa được bốc cặp',
                opponentNotInLeague: 'Người này không tham gia giải',
                didNotJoinLeague: 'Bạn chưa đăng ký giải này',
                feeNotPaid: 'Cần được xác nhận đóng phí trước khi thi đấu',
                matchAlreadyFinished: 'Trận này đã có kết quả',
                byeMatch: 'Bạn đang được miễn đấu ở vòng này',
                cannotChallengeYourself: 'Đây là mã QR của chính bạn',
                /* Riêng nhánh kép: cặp đấu nằm trong sơ đồ, không theo vòng. */
                notPairedInBracket: 'Người này không phải đối thủ của bạn trong sơ đồ',
                bracketNotDrawn: 'Giải chưa bốc sơ đồ',
                leagueHasChampion: 'Giải đã có vô địch',
            };
            toast.error(messages[code] || 'Không bắt đầu được trận, vui lòng thử lại')
            setDoiThuDaQuet(null)
            setMatchup(null)
            setQrLink('')
            setBusy(false)
        }
    }

    useEffect( () => {
        let {mode} = params;
        if (qrLink) {
            if (mode === 'calibration') {
                navigate('/calibrate/' + qrLink)
            } else if (mode === 'ranking') {
                navigate('/ranking/' + qrLink)
            } else if (!mode) {
                dispatchGenericCode(qrLink)
            } else if (laGiaiBocCapSan(league.type) && league.id) {
                if (!doiThuDaQuet) xemTruocDoiThu(qrLink)
            } else if (league.id) {
                navigate(`/league/${league.id}/competitor/${qrLink}`)
            }

        }
    }, [qrLink, league])

    const loadLeagueDataById = async () => {
        let {mode} = params;

        let leagueData 
        const rsp = await SBService.getLeagueById(mode)
        leagueData = rsp
        if(rsp.data)leagueData = rsp.data
        if (leagueData) {
            if (leagueData.startDate) {
                leagueData.startDateObj = moment(leagueData.startDate, ISO_8601)
                leagueData.endDateObj = moment(leagueData.endDate, ISO_8601)
            }
            setLeague(leagueData)
            setTitle(leagueData.name)
        } else {
            navigate(-1)
        }
    }

    /* Dock + nút dùng đúng component nút của design system như màn đăng ký giải,
       nên phải nằm trong vùng .biadi để lấy được style đó. */
    if (doiThuDaQuet) {
        const opp = matchup?.opponent
        const format = matchup?.format
        /* Nhánh loại trực tiếp không hoà, nên không in tỉ số hoà thay vì in một dấu
           gạch: một chỗ luôn trống chỉ làm người đọc phải tự đoán nó nghĩa là gì. */
        const coHoa = format ? format.drawAt !== null : false

        /* Màn này chỉ trả lời "tôi sắp đánh với ai, theo luật nào": mặt đối thủ và
           thể thức, vừa đúng một màn hình. Bảng so sánh hai cơ thủ và bảng điểm
           được/mất đã bỏ - người quét đang đứng cạnh bàn, thứ họ cần là nhận ra
           đúng người trước khi bấm, không phải một trang số liệu để cuộn. */
        return <div className="">
            <Navbar title={format || opp ? 'THÔNG TIN TRẬN ĐẤU' : title}/>
            <div className="biadi">
                <div className="shell">
                    <div className="pad">
                        {matchup?.league?.name ? <div className="mu-league">{matchup.league.name}</div> : null}

                        <div className="mu-hero">
                            <Avatar src={opp?.avatar} name={doiThuDaQuet.name} size="avah"
                                    rankClass={opp?.rankClass} score={opp?.score}
                                    onZoom={setAnhPhongTo}/>
                            <div className="mu-hero-name">{doiThuDaQuet.name}</div>
                            {opp ? (
                                <div className="mu-stats">
                                    <div className="mu-stat">
                                        <span className="k">Xếp hạng</span>
                                        <b>{opp.rankClass || '—'}</b>
                                    </div>
                                    <div className="mu-stat">
                                        <span className="k">Điểm</span>
                                        <b>{opp.score !== null ? Number(opp.score).toLocaleString('vi-VN') : '—'}</b>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {format ? (
                            <div className="mu-format">
                                <div className="label-acc">THỂ THỨC THI ĐẤU</div>
                                <div className="mu-race">
                                    Chạm {format.race} để thắng
                                    {coHoa ? ` (${format.drawAt}-${format.drawAt} hòa)` : ''}
                                </div>
                                {format.handicap ? (
                                    <div className="mu-handicap">
                                        {format.handicap.fromName} chấp {format.handicap.toName} {format.handicap.racks} ván
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {!matchup ? (
                            <div className="tiny" style={{padding: '12px 2px', textAlign: 'center'}}>
                                Bấm thách đấu để bắt đầu trận của vòng hiện tại. Sau đó hai bên nhập kết quả.
                            </div>
                        ) : null}
                    </div>
                    <div className="league-dock mu-dock">
                        <button className="btn btn-primary btn-block" disabled={busy}
                                onClick={() => moTranVoiDoiThu(doiThuDaQuet.id)}>
                            {busy ? 'Đang mở trận…' : 'Thách đấu'}
                        </button>
                        <button className="btn btn-quiet btn-block" style={{marginTop: 10}}
                                disabled={busy} onClick={huyQuet}>
                            Quét lại
                        </button>
                    </div>
                </div>
                <AvatarZoom anh={anhPhongTo} onClose={() => setAnhPhongTo(null)}/>
            </div>
        </div>
    }

    return  <div className="">
        <Navbar title={title}/>
        <div className="h-[60vh] flex justify-center items-center">
            <QrScanner
                onDecode={(result) => setQrLink(result)}
                onError={(error) => console.log(error?.message)}
                scanDelay={500}
            />
        </div>

    </div>
}

export default ScanQR